export default {
  namespaced: true,
  alarms_commands: {
    title: "Comandos de alarmas",
    add_alarm_command: 'Agregar comando de alarma',
    edit_alarm_command: 'Editar comando de alarma',
  },
};
